import '../stylus/header.styl'
import '../stylus/contatus.styl'


//THIS IS FOR THE STICKY NAVBAR
window.onscroll = () => {
    myFunction()
};

const myFunction = () => {
    const header = document.getElementById("myHeader");
    var sticky = 40;
    if(window.innerWidth < 1199) sticky = 0;
    if(window.innerWidth < 800) sticky = 15;

    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}


//THIS IS FOR THE NAVBAR
var hamburger = document.getElementById("navbar-toggler");
var navbarTogglerDemo03 = document.getElementById("navbarTogglerDemo03");
var myHeader = document.getElementById("myHeader");
hamburger.addEventListener("click", function () {
    if (!navbarTogglerDemo03.classList.contains('show')) {
        this.classList.add("is-active");
        myHeader.classList.add("deployed");
    } else {
        this.classList.remove("is-active");
        myHeader.classList.remove("deployed");
    }
}, false);
